import { NavLink, Outlet } from 'react-router-dom';

import css from './Certificate.module.css';

function Certificate() {
    return (
        <div className={css.main}>
            <div className={css.menu}>
                <nav className={css.nav}>
                    <NavLink to="/certificate/issue">Issue</NavLink>
                    <NavLink to="/certificate/overview">Overview</NavLink>
                </nav>
                {/* <nav className={css.nav}>
                    <NavLink to="/course/details">Details</NavLink>
                </nav> */}
            </div>
            <Outlet />
        </div>
    );
}

export default Certificate;